import { render, staticRenderFns } from "./AreaKinkage.vue?vue&type=template&id=c2554c3a&scoped=true"
import script from "./AreaKinkage.vue?vue&type=script&lang=js"
export * from "./AreaKinkage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2554c3a",
  null
  
)

export default component.exports